import HTML5Backend from 'react-dnd-html5-backend'

// Browsers fire dragend right after drop, so a longer gap means the event was lost.
const DRAG_END_GRACE_MS = 300

/*
  react-dnd-html5-backend 7 only ends a drag when the browser delivers `dragend`
  to the window. When that event is lost after a drop (the source node was
  detached or replaced by a re-render in between), the manager stays in a
  "dropped but still dragging" state: the drop never commits and the next
  dragenter/dragover/drop throws "Cannot call hover after drop."
  (Sentry MARKETPLACE-JS-8J6A). This wrapper ends such a drag itself.
*/
export default function createResilientHTML5Backend(manager) {
  const backend = HTML5Backend(manager)
  const monitor = manager.getMonitor()
  const actions = manager.getActions()
  const { handleTopDragEnterCapture, handleTopDrop } = backend
  let dragEndTimer = null

  const hasPendingDragEnd = () => monitor.isDragging() && monitor.didDrop()

  const endPendingDrag = () => {
    clearTimeout(dragEndTimer)
    dragEndTimer = null

    if (!hasPendingDragEnd()) return

    backend.clearCurrentDragSourceNode()
    actions.endDrag()
  }

  backend.handleTopDragEnterCapture = (e) => {
    endPendingDrag()
    handleTopDragEnterCapture(e)
  }

  backend.handleTopDrop = (e) => {
    endPendingDrag()

    if (!monitor.isDragging()) {
      backend.dropTargetIds = []
      return
    }

    handleTopDrop(e)

    if (hasPendingDragEnd()) {
      dragEndTimer = setTimeout(endPendingDrag, DRAG_END_GRACE_MS)
    }
  }

  const { teardown } = backend
  backend.teardown = () => {
    clearTimeout(dragEndTimer)
    dragEndTimer = null
    teardown.call(backend)
  }

  return backend
}
